import { CalendarDays } from 'lucide-react';
import { useAdminAuth } from '@/contexts/AdminAuthContext';

const ranges = [
  { id: '24h', label: '24 hours' },
  { id: '7d', label: '7 days' },
  { id: '30d', label: '30 days' },
  { id: 'custom', label: 'Custom' },
];

export const AdminTimeControls = () => {
  const { range, setRange, customStart, setCustomStart, customEnd, setCustomEnd } = useAdminAuth();
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="admin-time-controls">
      {ranges.map((option) => (
        <button
          key={option.id}
          onClick={() => setRange(option.id)}
          className={`h-9 px-3 text-xs font-semibold transition-colors rounded-sm ${range === option.id ? 'bg-[#2C5545] text-white' : 'border border-[#D7D1C7] bg-white text-[#4A4D4A] hover:border-[#2C5545]'}`}
          data-testid={`admin-range-${option.id}`}
        >
          {option.label}
        </button>
      ))}
      {range === 'custom' && (
        <div className="flex flex-wrap items-center gap-2 border-l border-[#D7D1C7] pl-2">
          <CalendarDays className="h-4 w-4 text-[#8A8D8A]" />
          <input type="date" value={customStart} onChange={(event) => setCustomStart(event.target.value)} className="h-9 border border-[#D7D1C7] bg-white px-2 text-xs text-[#1A1C18] rounded-sm" aria-label="Custom start date" data-testid="admin-custom-start-date" />
          <span className="text-xs text-[#8A8D8A]">to</span>
          <input type="date" value={customEnd} onChange={(event) => setCustomEnd(event.target.value)} className="h-9 border border-[#D7D1C7] bg-white px-2 text-xs text-[#1A1C18] rounded-sm" aria-label="Custom end date" data-testid="admin-custom-end-date" />
        </div>
      )}
    </div>
  );
};
